import { wooCommerceClient } from "./config";

/* PRODUCTS */

export const getProductsService = () => {
  return wooCommerceClient.get("/products");
};

export const getProductByIdService = (productId) => {
  return wooCommerceClient.get(`/products/${productId}`);
};

/* CATEGORIES */

export const getCategoriesService = () => {
  return wooCommerceClient.get("/products/categories");
};

/* ORDERS */

export const getOrdersService = () => {
  return wooCommerceClient.get("/orders");
};

/* CREATE ORDER */

export const createOrderService = (data) => {
  return wooCommerceClient.post("/orders", data);
};
/* FETCH SINGLE ORDER */

export const getOrderByIdService = (orderId) => {
  return wooCommerceClient.get(`/orders/${orderId}`);
};